{
  "hi": {
    "title": "Health indicators",
    "popover": {
      "openCiHealth": "Open CI health →",
      "loadedCount": "{{loaded}} of {{total}} CI",
      "empty": "No active indicators",
      "loadError": "Could not load indicators"
    },
    "tabs": {
      "activeHI": "Active HI",
      "history": "History"
    },
    "table": {
      "title": "Higher level indicators",
      "filters": {
        "hiFilterPlaceholder": "Select HI",
        "changeStatus": "Creation date"
      },
      "columns": {
        "ci": "CI",
        "hi": "HI",
        "value": "Severity",
        "change_status": "Created",
        "duration": "Duration",
        "summary": "Summary",
        "finished_at": "Finished at",
        "started_at": "Started at",
        "labels": "Labels",
        "annotations": "Annotations",
        "type": {
          "title": "Type"
        },
        "description": "Description",
        "template": "Template"
      }
    },
    "alerts": {
      "closeAction": "Close alert",
      "closeSelected": "Close selected alerts ({{count}})",
      "forceCloseTitle": "Confirm alert closure",
      "forceCloseDescription": "This alert or some selected alerts are automatically closed. Force close them?",
      "forceCloseConfirm": "Force close",
      "closeError": "Could not close alerts",
      "closePartialError_one": "Could not close {{count}} alert: {{messages}}",
      "closePartialError_other": "Could not close {{count}} alerts: {{messages}}"
    }
  },
  "srm": {
    "types": {
      "CHANGED_ATTRIBUTE": "Attribute changed",
      "CREATE_CI": "CI created",
      "DELETE_CI": "CI deleted"
    }
  },
  "config": {
    "title": "Server status",
    "tabs": {
      "backgroundTasks": "Background tasks",
      "history": "History"
    },
    "types": {
      "HI_LINK_ON": "Hi enabled",
      "HI_LINK_OFF": "Hi disabled",
      "METRIC_ON": "Metric enabled",
      "METRIC_OFF": "Metric disabled",
      "ADD_USER": "User added",
      "DELETE_USER": "User deleted",
      "SERVICE_UP": "Service up",
      "SERVICE_DOWN": "Service down",
      "SRM_UP": "SRM up",
      "SRM_DOWN": "SRM down"
    }
  },
  "table": {
    "new": "New",
    "groupBy": "Group by",
    "total": "Total",
    "timeRanges": {
      "minutes": "min.",
      "hours": "h.",
      "days": "d.",
      "weeks": "w.",
      "months": "m.",
      "years": "y."
    }
  },
  "general": {
    "noDefaultDashboards": "Default dashboards not found",
    "defaultDashboards": "Default dashboards"
  },
  "log": {
    "title": "Notifications",
    "state": "State",
    "empty": "No new notifications",
    "counters": {
      "total": "Import records",
      "created": "CIs created",
      "modified": "CIs modified",
      "unchanged": "CIs unchanged",
      "skipped": "CIs skipped",
      "deleted": "CIs deleted",
      "not_found": "CIs not found",
      "errors": "CI errors",
      "links_created": "Links created"
    }
  },
  "subscriptions": {
    "title": "Subscriptions",
    "fields": {
      "enable": "Enable",
      "name": "Name",
      "label": "Display name",
      "receiver": "Receiver",
      "resolve": "Need resolve",
      "groupWait": "Grouping wait time",
      "groupInterval": "Group extension interval",
      "repeatInterval": "Notice interval",
      "bellSubscribe": "Subscribe to notifications",
      "extendedFilter": "Extended events filter"
    },
    "unsavedChanges": "There are unsaved changes. Continue?",
    "editNotifications": "Edit notifications",
    "new": "New subscription"
  },
  "senders": {
    "deleteTitle": "Attention! All <strong>inactive</strong> recipients associated with the sender <br/>will be deleted together with the sender. Continue?"
  },
  "receivers": {
    "deleteTitle": "Attention! Deleting this recipient will also remove <br/> all related <strong>inactive</strong> subscriptions. Continue?"
  }
}
